export const PORTFOLIO = {
  name: 'Sai Bhargav Rallapalli',
  shortName: 'Sai Bhargav',
  tagline: 'Building conversational AI that feels human',
  location: 'Bengaluru, India',
  email: 'saibhargavrallapalli@gmail.com',
  avatar: 'https://github.com/SaiBhargavRallapalli.png',
  resume: '/Sai_Bhargav_Rallapalli_Resume.pdf',
  blog: 'https://saibhargavr.medium.com/',
  social: {
    github: 'https://github.com/SaiBhargavRallapalli',
    linkedin: 'https://linkedin.com/in/sai-bhargav-rallapalli/',
    twitter: 'https://twitter.com/rs_bhargav',
  },
};

export const ROLES = [
  'Conversational AI Developer',
  'Backend Engineer',
  'Full-Stack Developer',
  'AI Systems Architect',
];

export const STATS = [
  { value: '5+', label: 'Years Experience' },
  { value: 'M+', label: 'Users Served' },
  { value: '10+', label: 'Platforms' },
  { value: '3', label: 'Shipped Products' },
];

export const ABOUT = {
  intro:
    "I'm a software developer specializing in Conversational AI and backend systems. I architect scalable platforms that serve millions of users across web, mobile, STB, speaker, and auto devices.",
  paragraphs: [
    'My journey started after university with a fascination for interactive, user-focused applications. Today I lead development of AI-powered conversational experiences at Jio Platforms, building robust Node.js backends and microservices.',
    'I believe in code that is not just functional but meaningful — solving real problems with clean, maintainable solutions while staying grounded in software fundamentals.',
  ],
  highlights: [
    {
      title: 'Clean Architecture',
      description: 'Designing maintainable systems with microservices and clear boundaries.',
    },
    {
      title: 'AI-First Thinking',
      description: 'Building LLM-powered products with LangChain, RAG, and agent workflows.',
    },
    {
      title: 'Scale & Impact',
      description: 'Shipping features used by millions across diverse device ecosystems.',
    },
  ],
};

export const EXPERIENCE = [
  {
    company: 'Jio Platforms Limited',
    role: 'SDE II',
    period: 'Jan 2022 — Present',
    location: 'Bangalore, India',
    current: true,
    description:
      'Leading development of scalable conversational AI solutions serving millions of users. Building robust backend systems with Node.js and microservices architecture.',
    tech: ['Node.js', 'Conversational AI', 'Microservices', 'LangChain', 'Docker', 'K8s'],
  },
  {
    company: 'Data Semantics',
    role: 'Software Engineer',
    period: 'Mar 2019 — Jan 2022',
    location: 'Bengaluru, India',
    current: false,
    description:
      'Developed intelligent chatbot applications using NLP and machine learning. Built RESTful APIs and optimized database performance for client projects.',
    tech: ['Python', 'NLP', 'REST APIs', 'MySQL', 'Chatbots'],
  },
];

export const EDUCATION = {
  degree: 'B.E (ECE)',
  institution: 'Visvesvaraya Technological University',
  period: '2012 — 2016',
};

export const AWARDS = [
  { name: 'Best Debutant', issuer: 'Jio Platforms Ltd', year: '2022' },
  { name: 'Business Excellence', issuer: 'Jio Platforms Ltd', year: '2024' },
];

export const SKILLS = [
  'JavaScript', 'Node.js', 'Python', 'React', 'TypeScript',
  'LangChain', 'LangGraph', 'FastAPI', 'PostgreSQL', 'Redis',
  'Docker', 'Kubernetes', 'REST APIs', 'Conversational AI',
  'LLM', 'GenAI', 'Microservices', 'Git', 'Express.js',
];

export const PROJECTS = [
  {
    id: 1,
    title: 'MorseCode Translator',
    category: 'web',
    description:
      'A polished web app that translates text to Morse code and vice versa with real-time feedback and clean UX.',
    features: [
      'Bidirectional text ↔ Morse translation with instant visual feedback.',
      'Lightweight, responsive interface built for quick daily use.',
    ],
    tech: ['JavaScript', 'HTML', 'CSS'],
    github: 'https://github.com/SaiBhargavRallapalli/translator-app',
    live: 'https://morsecode-decoder.netlify.app/',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  {
    id: 2,
    title: 'JioFit Bot',
    category: 'ai',
    description:
      'An AI-powered fitness tracker on Telegram that monitors activity, recommends workouts and diet plans, and curates playlists and how-to videos.',
    features: [
      'Personalized fitness and diet recommendations powered by LangChain.',
      'Integrated playlist and video suggestions for each activity type.',
    ],
    tech: ['LangChain', 'Python', 'Telegram Bot API'],
    live: 'https://t.me/JioFitBot',
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  },
  {
    id: 3,
    title: 'Custom Q&A Maker',
    category: 'ai',
    description:
      'An AI application that lets users create custom Q&A datasets for their specific domains using Streamlit and FastAPI.',
    features: [
      'Domain-specific Q&A generation with LangChain pipeline.',
      'Streamlit frontend with FastAPI backend for flexible deployment.',
    ],
    tech: ['Python', 'Streamlit', 'LangChain', 'FastAPI'],
    github: 'https://github.com/SaiBhargavRallapalli/qnamaker',
    live: 'https://qnamaker.streamlit.app/',
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  },
];

export const NAV_SECTIONS = [
  { id: 'hero', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Work' },
  { id: 'contact', label: 'Contact' },
];
